import * as React from "react";
const SvgMoreIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 5, height: 8, viewBox: "0 0 5 8", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.818115 1L3.81812 4L0.818115 7", stroke: "#1A1A1A", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMoreIcon;
